/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Stage_DeliveredInputs */

const tr_geliver_tracking_stage_delivered = /** @type {(inputs: Geliver_Tracking_Stage_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim Edildi`)
};

const en_geliver_tracking_stage_delivered = /** @type {(inputs: Geliver_Tracking_Stage_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

const de_geliver_tracking_stage_delivered = /** @type {(inputs: Geliver_Tracking_Stage_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugestellt`)
};

const ru_geliver_tracking_stage_delivered = /** @type {(inputs: Geliver_Tracking_Stage_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставлено`)
};

/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Geliver_Tracking_Stage_DeliveredInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_stage_delivered = /** @type {((inputs?: Geliver_Tracking_Stage_DeliveredInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Stage_DeliveredInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_stage_delivered(inputs)
	if (locale === "de") return de_geliver_tracking_stage_delivered(inputs)
	if (locale === "ru") return ru_geliver_tracking_stage_delivered(inputs)
	return tr_geliver_tracking_stage_delivered(inputs)
});